<template>
  <div>
    <b-row>
      <b-col>
        <b-row align-h="center" align="center">
          <b-col>
            <b-row align-h="center" align="center">
              <b-col cols="12" md="6" lg="3">
                <h1>Reportes</h1>
              </b-col>
            </b-row>

            <p></p>
            <b-row align-h="center" align="center">
              <b-col cols="12" md="6" lg="3" style="cursor: pointer">
                <b-form-select
                  v-model="reporteSelected"
                  :options="tipoReporte"
                ></b-form-select>
              </b-col>
            </b-row>
            <p></p>

            <b-row
              v-if="reporteSelected == 1 || reporteSelected == 2"
              align-h="center"
              align="center"
            >
              <b-col cols="12" md="6" lg="3">
                <b-form-select
                  v-model="selectedFacturaConciliacionReporte"
                  :options="facturasConciliacionReporte"
                  value-field="descripcion"
                  text-field="descripcion"
                ></b-form-select>
              </b-col>
            </b-row>

            <b-row v-if="reporteSelected == 3">
              <b-col>
                <b-row>
                  <b-col>
                    <b-form-checkbox
                      v-model="banderaTodosDepartamentos"
                      name="checkbox-1"
                      value="1"
                      unchecked-value="0"
                    >
                      Todos los departamentos
                    </b-form-checkbox>
                  </b-col>
                </b-row>

                <b-row
                  align-h="center"
                  align="center"
                  v-if="banderaTodosDepartamentos != 1"
                >
                  <b-col cols="12" md="6" lg="3">
                    <b-form-select
                      @change="recorreUnidadesTablaVales"
                      v-model="departamentoOpcion"
                      :options="departamentos"
                      value-field="descDepartamento"
                      text-field="descDepartamento"
                    ></b-form-select>
                  </b-col>
                </b-row>

                <p></p>

                <b-row v-if="banderaTodosDepartamentos != 1">
                  <b-col>
                    <b-form-checkbox
                      v-model="banderaTodosUnidades"
                      name="checkbox-1"
                      value="1"
                      unchecked-value="0"
                    >
                      Todas las unidades
                    </b-form-checkbox>
                  </b-col>
                </b-row>

                <b-row
                  align-h="center"
                  align="center"
                  v-if="
                    banderaTodosDepartamentos != 1 && banderaTodosUnidades != 1
                  "
                >
                  <b-col cols="12" md="6" lg="3">
                    <b-form-select
                      v-model="unidadOpcion"
                      :options="unidadesActualTabla"
                      value-field="descUnidad"
                      text-field="descUnidad"
                    ></b-form-select>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>

            <p></p>

            <b-row v-if="reporteSelected == 3">
              <b-col>
                <b-check v-model="checkFacturados" value="1" unchecked-value="0"
                  >Facturados</b-check
                >
              </b-col>
            </b-row>

            <p></p>

            <b-row v-if="reporteSelected == 3 && checkFacturados == 0">
              <b-col>
                <b-row align-h="center" align="center">
                  <b-col cols="12" md="6" lg="3" style="cursor: pointer">
                    <b-form-datepicker
                      v-model="fechaInicio"
                    ></b-form-datepicker>
                  </b-col>
                </b-row>
                <p></p>
                <b-row align-h="center" align="center">
                  <b-col cols="12" md="6" lg="3" style="cursor: pointer">
                    <b-form-datepicker v-model="fechaFinal"></b-form-datepicker>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>

            <b-row
              v-if="reporteSelected == 3 && checkFacturados == 1"
              align-h="center"
              align="center"
            >
              <b-col cols="12" md="6" lg="3">
                <b-form-select
                  v-model="selectedFacturaConciliacionReporte"
                  :options="facturasConciliacionReporte"
                  value-field="descripcion"
                  text-field="descripcion"
                ></b-form-select>
              </b-col>
            </b-row>

            <p></p>
            <b-row align-h="center" align="center">
              <b-col cols="12" md="6" lg="3">
                <b-button
                  pill
                  variant="success"
                  size="lg"
                  @click="generarReportes"
                  >Generar</b-button
                >
              </b-col>
            </b-row>
            <p></p>
            <b-row align-h="center" align="center" v-if="reporteSelected == 3">
              <b-col cols="12" md="8" lg="6">
                <b-table
                  :items="vales"
                  :fields="fieldsVales"
                  :select-mode="selectModeVales"
                  responsive="lg"
                  ref="selectableTable"
                  selectable
                  @row-selected="onRowSelectedVales"
                  per-page="1000"
                  v-if="banderaReportes == 1"
                >
                  <template #cell(selected)="{ rowSelected }">
                    <template v-if="rowSelected">
                      <span aria-hidden="true">&check;</span>
                      <span class="sr-only">Selected</span>
                    </template>
                    <template v-else>
                      <span aria-hidden="true">&nbsp;</span>
                      <span class="sr-only">Not selected</span>
                    </template>
                  </template>
                </b-table>
              </b-col>
            </b-row>

            <b-row v-if="banderaSpinnerDescargarReporte != 1">
              <b-col>
                <b-row
                  align-h="center"
                  align="center"
                  v-if="reporteSelected == 3"
                >
                  <b-col cols="12" md="6" lg="3">
                    <b-link @click="descargaTablaVales"
                      >Descargar Excel Vales</b-link
                    >
                    <b-row
                      v-if="banderaMostrarBotonTrash == 1"
                      class="mt-5 pt-3"
                      align-h="center"
                    >
                      <b-col cols="6" md="4" lg="2">
                        <b-icon
                          icon="trash-fill"
                          font-scale="2"
                          class="mb-1 mt-4"
                          @click="borrarVale"
                          style="cursor: pointer"
                        ></b-icon>
                        <h5>Borrar</h5>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <p></p>
                <b-row
                  align-h="center"
                  align="center"
                  v-if="reporteSelected != 3"
                >
                  <b-col cols="12" md="6" lg="3">
                    <b-link @click="descargaReportes">Descargar Reporte</b-link>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <b-row>
          <b-modal
            hide-footer
            header-bg-variant="dark"
            header-text-variant="light"
            v-model="modalShow9"
            title="Opciones de vale"
          >
            <b-row v-if="banderaOpciones == 0" align-h="center" align="center">
              <b-col cols="6" md="4" lg="2">
                <b-icon
                  icon="printer-fill"
                  font-scale="2"
                  class="mb-1 mt-4"
                  @click="imprimirVale"
                  style="cursor: pointer"
                ></b-icon>
                <h5>Imprimir</h5>
              </b-col>
              <b-col cols="6" md="4" lg="2">
                <b-icon
                  icon="x-circle-fill"
                  font-scale="2"
                  class="mb-1 mt-4"
                  @click="eliminarVale"
                  style="cursor: pointer"
                ></b-icon>
                <h5>Cancelar</h5>

                <b-modal
                  hide-footer
                  header-bg-variant="dark"
                  header-text-variant="light"
                  title="Descargue su vale"
                  v-model="modalShow10"
                  v-if="banderaImprimir == 1"
                >
                  <b-row>
                    <b-col>
                      <embed
                        :src="valeImprimirSrc"
                        frameborder="0"
                        width="100%"
                        height="800px"
                      />
                    </b-col>
                  </b-row>
                </b-modal>
              </b-col>
            </b-row>
            <p></p>
            <b-row v-if="banderaOpciones == 1" align-h="center" align="center">
              <b-spinner
                label="Espere un momento, por favor, se está consultando su vale..."
              ></b-spinner>
            </b-row>
            <b-row v-if="banderaOpciones == 2" align-h="center" align="center">
              <b-spinner
                label="Espere un momento, por favor, se está cancelando su vale..."
              ></b-spinner>
            </b-row>
            <h5><strong>Datos generales:</strong></h5>
            <p></p>
            <b-row v-if="banderaVisualizar == 1">
              <b-col>
                <b>{{ "Vehiculo: " }} </b>
                {{ this.contenidoVisualizar.unidad.descUnidad }}
              </b-col>
            </b-row>
            <b-row v-if="banderaVisualizar == 1">
              <b-col>
                <b>{{ "Departamento: " }} </b>
                {{ this.contenidoVisualizar.departamento.descDepartamento }}
              </b-col>
            </b-row>
            <b-row v-if="banderaVisualizar == 1">
              <b-col>
                <b>{{ "Operador: " }} </b>
                {{ this.contenidoVisualizar.operador }}
              </b-col>
            </b-row>
            <b-row v-if="banderaVisualizar == 1">
              <b-col>
                <b>{{ "Nota interna: " }} </b>
                {{ this.contenidoVisualizar.notaInterna }}
              </b-col>
            </b-row>
            <b-row v-if="banderaVisualizar == 1">
              <b-col>
                <b> {{ "Nota bomba: " }} </b>
                {{ this.contenidoVisualizar.notaBomba }}
              </b-col>
            </b-row>
            <b-row v-if="banderaVisualizar == 1">
              <b-col>
                <b> {{ "Nota motivo: " }} </b>
                {{ this.contenidoVisualizar.notaMotivo }}
              </b-col>
            </b-row>
            <b-row v-if="banderaVisualizar == 1">
              <b-col>
                <b> {{ "Nota clasificacion: " }} </b>
                {{ this.contenidoVisualizar.notaClasificacion }}
              </b-col>
            </b-row>

            <p></p>
            <h5><strong> Datos del vale: </strong></h5>
            <p></p>
            <b-row v-if="banderaVisualizar == 1">
              <b-col>
                <b>{{ "Estatus: " }} </b> {{ this.contenidoVisualizar.estatus }}
              </b-col>
            </b-row>
            <b-row v-if="banderaVisualizar == 1">
              <b-col>
                <b>{{ "Usuario emisión: " }} </b>
                {{ this.contenidoVisualizar.usrEmitio }}
              </b-col>
            </b-row>
            <b-row
              v-if="
                banderaVisualizar == 1 &&
                this.contenidoVisualizar.estatus == 'C'
              "
            >
              <b-col>
                <b>{{ "Usuario canceló: " }} </b>
                {{ this.contenidoVisualizar.usrCancelo }}
              </b-col>
            </b-row>
            <b-row v-if="banderaVisualizar == 1">
              <b-col>
                <b>{{ "Folio: " }} </b> {{ this.contenidoVisualizar.folio }}
              </b-col>
            </b-row>
            <b-row v-if="banderaVisualizar == 1">
              <b-col>
                <b>{{ "Proveedor: " }} </b>
                {{ this.contenidoVisualizar.proveedor.proveedor }}
              </b-col>
            </b-row>
            <b-row v-if="banderaVisualizar == 1">
              <b-col>
                <b>{{ "Litros: " }} </b>
                {{ this.contenidoVisualizar.nLitrosVale }}
              </b-col>
            </b-row>
            <b-row v-if="banderaVisualizar == 1">
              <b-col>
                <b>{{ "Tipo combustible: " }} </b>
                {{ this.contenidoVisualizar.unidad.tipoCombustible }}
              </b-col>
            </b-row>
            <b-row v-if="banderaVisualizar == 1">
              <b-col>
                <b>{{ "Total: " }} </b>
                {{ this.contenidoVisualizar.costoTotalVale }}
              </b-col>
            </b-row>
            <b-row v-if="banderaVisualizar == 1">
              <b-col>
                <b>{{ "Fecha de emisión: " }} </b>
                {{ this.contenidoVisualizar.fechaEmision }}
              </b-col>
            </b-row>
            <b-row v-if="banderaVisualizar == 1">
              <b-col>
                <b>{{ "Fecha de vencimiento: " }} </b>
                {{ this.contenidoVisualizar.fechaVigencia }}
              </b-col>
            </b-row>

            <p></p>
            <h5><strong>Datos de la carga:</strong></h5>
            <p></p>
            <b-row v-if="banderaVisualizar == 1">
              <b-col>
                <b>{{ "Folio ticket de bomba: " }} </b>
                {{ this.contenidoVisualizar.folioBomba }}
              </b-col>
            </b-row>
            <b-row v-if="banderaVisualizar == 1">
              <b-col>
                <b>{{ "Litros Cargados: " }} </b>
                {{ this.contenidoVisualizar.litrosFactura }}
              </b-col>
            </b-row>
            <b-row v-if="banderaVisualizar == 1">
              <b-col>
                <b>{{ "Tipo de combustible: " }} </b>
                {{ this.contenidoVisualizar.tipoConsumible }}
              </b-col>
            </b-row>

            <b-row v-if="banderaVisualizar == 1">
              <b-col>
                <b>{{ "Total cargado: " }} </b>
                {{ this.contenidoVisualizar.costoTotalFactura }}
              </b-col>
            </b-row>

            <b-row v-if="banderaVisualizar == 1">
              <b-col>
                <b>{{ "Fecha de carga: " }} </b>
                {{ this.contenidoVisualizar.fechaCarga }}
              </b-col>
            </b-row>

            <b-row v-if="banderaVisualizar == 1">
              <b-col>
                <b>{{ "Factura: " }} </b> {{ this.contenidoVisualizar.factura }}
              </b-col>
            </b-row>
          </b-modal>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>




<script>
import axios from "axios";
import FileSaver from "file-saver";

export default {
  computed: {
    token: {
      get: function () {
        return this.$store.state.user.token;
      },
      set: function (newIsWorking) {
        this.$store.commit("updateToken", newIsWorking);
      },
    },
  },

  data() {
    return {
      //variables Generacion Vale
      cliente: "",
      //url: "http://192.168.0.100:8080/",
      //url: "https://optimal-central-pug.ngrok-free.app/",
      //url: "https://tphavawsqa.a.pinggy.link/",
      //url: "http://192.168.0.101:8080/",
      url: "https://recaudacion.gobrecservices.com/",

      //vale: '',
      modalShow9: false,

      banderaVisualizar: 0,

      banderaImprimir: 0,
      banderaReportes: 0,
      banderaOpciones: 0,

      banderaMostrarBotonTrash: 0,

      archivoValesBase64: "",
      //archivoTablaValesBase64: null,
      archivoReportesBase64: "",

      unidadesActualTabla: [],
      unidadesActualTablaForUnidad: [],

      valeSeleccionado: "",
      valeImprimirSrc: "",

      contenidoVisualizar: "",

      ///variables Reportes

      fechaInicio: "",
      fechaFinal: "",
      reporteSelected: null,

      tipoReporte: [
        { value: null, text: "Seleccione el reporte" },
        { value: "1", text: "Bitacora" },
        { value: "2", text: "Póliza" },
        { value: "3", text: "Vales Emitidos" },
      ],

      departamentos: [],

      fieldsVales: [
        "folio",
        "unidad",
        "departamento",
        "consumible",
        "tipoConsumible",
        "estado",
      ],
      vales: [],
      selectModeVales: "single",

      unidadesTabla: [],
      unidadesTablaForUnidad: [],

      banderaTodosDepartamentos: 0,
      banderaTodosUnidades: 0,

      departamentoOpcion: null,
      unidadOpcion: null,

      valesConsulta: "",

      selectedFacturaConciliacionReporte: "",
      facturasConciliacionReporte: [],

      checkFacturados: 0,

      banderaSpinnerDescargarReporte: 0,

      nombreZip: "",
    };
  },

  created: function () {
    const queryString = window.location.href;

    const url = new URL(queryString);

    const cliente = url.pathname.split("/")[1];

    this.cliente = cliente;

    axios({
      method: "post",
      url: this.url + "catalogosum",
      params: { codeClient: this.cliente },
      data: null,
      headers: {
        Authorization: this.token,
      },
    })
      .then((res) => {
        this.departamentos = res.data.departamentos;
        this.unidades = res.data.unidades;
        this.operadores = res.data.operadores;
        this.proveedores = res.data.proveedores;

        this.unidadesTabla = res.data.unidades;

        this.facturasConciliacionReporte = res.data.facturas;

        if (
          this.facturasConciliacionReporte != null &&
          this.facturasConciliacionReporte.length > 0
        ) {
          this.selectedFacturaConciliacionReporte =
            this.facturasConciliacionReporte[0].descripcion;
        }
      })
      .catch((err) => {
        if (
          err.response.status == 400 ||
          err.response.status == 304 ||
          err.response.status == 403 ||
          err.response.status == 404
        ) {
          alert("Servicio no disponible, intente de nuevo más tarde");
        } else if (err.response.status == 500) {
          alert("Error en la red, verifique su conexión a internet 3");
        } else {
          alert(err);
        }
      });
  },

  methods: {
    onRowSelectedVales(itemSelected) {
      this.valeSeleccionado = itemSelected;

      axios({
        method: "post",
        url: this.url + "imprimirvaleadmin",

        data: {
          folio: this.valeSeleccionado[0].folio,
        },
        headers: {
          Authorization: this.token,
        },
      })
        .then((res) => {
          this.contenidoVisualizar = res.data;

          this.banderaVisualizar = 1;

          this.modalShow9 = true;
        })
        .catch((err) => {
          if (
            err.response.status == 400 ||
            err.response.status == 304 ||
            err.response.status == 403 ||
            err.response.status == 404
          ) {
            alert("Servicio no disponible, intente de nuevo más tarde");
          } else if (err.response.status == 500) {
            alert("Error en la red, verifique su conexión a internet");
          } else {
            if (err.config.headers.Authorization != null) {
              const queryString = window.location.href;
              const url = new URL(queryString);
              const cliente = url.pathname.split("/")[1];
              window.location.href = "/" + cliente + "/login";
            }
            alert(err);
          }
        });
    },

    imprimirVale() {
      this.banderaOpciones = 1;
      this.banderaImprimir = 1;

      this.modalShow10 = true;

      axios({
        method: "post",
        url: this.url + "imprimirvaleadmin",

        data: {
          folio: this.valeSeleccionado[0].folio,
        },
        headers: {
          Authorization: this.token,
        },
      })
        .then((res) => {
          this.valeImprimirSrc = "data:application/pdf;base64," + res.data.pdf;
          this.banderaOpciones = 0;
        })
        .catch((err) => {
          if (
            err.response.status == 400 ||
            err.response.status == 304 ||
            err.response.status == 403 ||
            err.response.status == 404
          ) {
            alert("Servicio no disponible, intente de nuevo más tarde");
          } else if (err.response.status == 500) {
            alert("Error en la red, verifique su conexión a internet");
          } else {
            if (err.config.headers.Authorization != null) {
              const queryString = window.location.href;
              const url = new URL(queryString);
              const cliente = url.pathname.split("/")[1];
              window.location.href = "/" + cliente + "/login";
            }

            this.banderaOpciones = 0;

            alert(err);
          }
        });
    },

    eliminarVale() {
      this.banderaOpciones = 2;

      axios({
        method: "post",
        url: this.url + "cancelavale",

        data: {
          folio: this.valeSeleccionado[0].folio,
        },
        headers: {
          Authorization: this.token,
        },
      })
        .then(() => {
          this.banderaOpciones = 0;
        })
        .catch((err) => {
          if (
            err.response.status == 400 ||
            err.response.status == 304 ||
            err.response.status == 403 ||
            err.response.status == 404
          ) {
            alert("Servicio no disponible, intente de nuevo más tarde");
          } else if (err.response.status == 500) {
            alert("Error en la red, verifique su conexión a internet");
          } else {
            if (err.config.headers.Authorization != null) {
              const queryString = window.location.href;
              const url = new URL(queryString);
              const cliente = url.pathname.split("/")[1];
              window.location.href = "/" + cliente + "/login";
            }

            this.banderaOpciones = 0;

            alert(err);
          }
        });
    },

    borrarVale() {
      axios({
        method: "post",
        url: this.url + "vales",

        data: {
          fechaInicio: this.fechaInicio,
          fechaFinal: this.fechaFinal,
          reporteSelected: this.reporteSelected,
          descDepartamento: this.departamentoOpcion,
          estado: this.estado,
          descUnidad: this.unidadOpcion,
          descFactura: this.selectedFacturaConciliacionReporte,
          filtraFactura: this.checkFacturados,
          borrar: true,
        },
        headers: {
          Authorization: this.token,
        },
      })
        .then((res) => {
          //if(this.estado == 'C'){
          //    this.estado = <font-awesome-icon icon="js" />
          //}

          this.vales = res.data;

          if (this.vales.length > 0) {
            this.banderaMostrarBotonTrash = 1;
          } else {
            this.banderaMostrarBotonTrash = 0;
          }

          if (this.checkFacturados == false) {
            this.checkFacturados = 0;
          }
          if (this.checkFacturados == true) {
            this.checkFacturados = 1;
          }
        })
        .catch((err) => {
          if (
            err.response.status == 400 ||
            err.response.status == 304 ||
            err.response.status == 403 ||
            err.response.status == 404
          ) {
            alert("Servicio no disponible, intente de nuevo más tarde");
          } else if (err.response.status == 500) {
            alert("Error en la red, verifique su conexión a internet");
          } else {
            if (err.config.headers.Authorization != null) {
              const queryString = window.location.href;
              const url = new URL(queryString);
              const cliente = url.pathname.split("/")[1];
              window.location.href = "/" + cliente + "/login";
            }

            alert(err);
          }
        });
    },

    generarReportes() {
      this.banderaReportes = 1;
      this.banderaMostrarBotonTrash = 0;

      if (this.checkFacturados == 0) {
        this.checkFacturados = false;
      }
      if (this.checkFacturados == 1) {
        this.checkFacturados = true;
      }

      //CODIGO PARA BITACORA

      if (this.reporteSelected == 1) {
        this.checkFacturados = true;

        axios({
          method: "post",
          url: this.url + "reportesum",

          data: {
            fechaInicio: this.fechaInicio,
            fechaFinal: this.fechaFinal,
            reporteSelected: this.reporteSelected,
            descDepartamento: this.departamentoOpcion,
            estado: this.estado,
            descUnidad: this.unidadOpcion,
            descFactura: this.selectedFacturaConciliacionReporte,
            filtraFactura: this.checkFacturados,
          },
          headers: {
            Authorization: this.token,
          },
        })
          .then((res) => {
            this.archivoReportesBase64 = res.data[0].zip;
            this.nombreZip = res.data[0].nombre;

            this.descargaReportes();
          })
          .catch((err) => {
            if (
              err.response.status == 400 ||
              err.response.status == 304 ||
              err.response.status == 403 ||
              err.response.status == 404
            ) {
              alert("Servicio no disponible, intente de nuevo más tarde");
            } else if (err.response.status == 500) {
              alert("Error en la red, verifique su conexión a internet");
            } else {
              if (err.config.headers.Authorization != null) {
                const queryString = window.location.href;
                const url = new URL(queryString);
                const cliente = url.pathname.split("/")[1];
                window.location.href = "/" + cliente + "/login";
              }

              alert(err);
            }
          });
      }

      //CODIGO PARA POLIZA

      if (this.reporteSelected == 2) {
        axios({
          method: "post",
          url: this.url + "reportesum",

          data: {
            fechaInicio: this.fechaInicio,
            fechaFinal: this.fechaFinal,
            reporteSelected: this.reporteSelected,
            descDepartamento: this.departamentoOpcion,
            estado: this.estado,
            descUnidad: this.unidadOpcion,
            descFactura: this.selectedFacturaConciliacionReporte,
            filtraFactura: this.checkFacturados,
          },
          headers: {
            Authorization: this.token,
          },
        })
          .then((res) => {
            this.archivoReportesBase64 = res.data.xlsx;
          })
          .catch((err) => {
            if (
              err.response.status == 400 ||
              err.response.status == 304 ||
              err.response.status == 403 ||
              err.response.status == 404
            ) {
              alert("Servicio no disponible, intente de nuevo más tarde");
            } else if (err.response.status == 500) {
              alert("Error en la red, verifique su conexión a internet");
            } else {
              if (err.config.headers.Authorization != null) {
                const queryString = window.location.href;
                const url = new URL(queryString);
                const cliente = url.pathname.split("/")[1];
                window.location.href = "/" + cliente + "/login";
              }
              alert(err.response.status);
            }
          });
      }

      //CODIGO PARA VALES EMITIDOS

      /*SI NO ESTA ACTIVADA LA OPCION TODOS LOS DEPARTAMENTOS Y LA SELECCION ES NULA SE MUESTRA IMPRIME EL ALERT >>> SELECCIONE UN DEPARTAMENTO*/

      if (this.reporteSelected == 3) {
        if (
          this.banderaTodosDepartamentos == 0 &&
          this.departamentoOpcion == null
        ) {
          alert("SELECCIONE UN DEPARTAMENTO");
        }
      }

      /*SI ESTA ACTIVADA LA OPCION TODOS LOS DEPARTAMENTOS SE MUESTRA LA TABLA*/
      if (this.banderaTodosDepartamentos == 1) {
        this.departamentoOpcion = null;
        this.unidadOpcion = null;

        if (this.reporteSelected == 3) {
          axios({
            method: "post",
            url: this.url + "vales",

            data: {
              fechaInicio: this.fechaInicio,
              fechaFinal: this.fechaFinal,
              reporteSelected: this.reporteSelected,
              descDepartamento: this.departamentoOpcion,
              estado: this.estado,
              descUnidad: this.unidadOpcion,
              descFactura: this.selectedFacturaConciliacionReporte,
              filtraFactura: this.checkFacturados,
            },
            headers: {
              Authorization: this.token,
            },
          })
            .then((res) => {
              //if(this.estado == 'C'){
              //    this.estado = <font-awesome-icon icon="js" />
              //}

              this.vales = res.data;

              if (this.vales.length > 0) {
                this.banderaMostrarBotonTrash = 1;
              } else {
                this.banderaMostrarBotonTrash = 0;
              }

              if (this.checkFacturados == false) {
                this.checkFacturados = 0;
              }
              if (this.checkFacturados == true) {
                this.checkFacturados = 1;
              }
            })
            .catch((err) => {
              if (
                err.response.status == 400 ||
                err.response.status == 304 ||
                err.response.status == 403 ||
                err.response.status == 404
              ) {
                alert("Servicio no disponible, intente de nuevo más tarde");
              } else if (err.response.status == 500) {
                alert("Error en la red, verifique su conexión a internet");
              } else {
                if (err.config.headers.Authorization != null) {
                  const queryString = window.location.href;
                  const url = new URL(queryString);
                  const cliente = url.pathname.split("/")[1];
                  window.location.href = "/" + cliente + "/login";
                }

                alert(err);
              }
            });
        }
      }

      if (
        this.banderaTodosDepartamentos == 0 &&
        this.departamentoOpcion != null
      ) {
        /*SI NO ESTA ACTIVADA LA OPCION TODAS LAS UNIDADES Y LA SELECCION ES NULA SE MUESTRA IMPRIME EL ALERT >>> SELECCIONE UNA UNIDAD*/
        if (this.banderaTodosUnidades == 0 && this.unidadOpcion == null) {
          alert("SELECCIONE UNA UNIDAD");
        }

        /*SI NO ESTA ACTIVADA LA OPCION TODAS LAS UNIDADES Y LA SELECCION NO ES NULA SE MUESTRA LA TABLA*/
        if (this.banderaTodosUnidades == 0 && this.unidadOpcion != null) {
          if (this.reporteSelected == 3) {
            axios({
              method: "post",
              url: this.url + "vales",

              data: {
                fechaInicio: this.fechaInicio,
                fechaFinal: this.fechaFinal,
                reporteSelected: this.reporteSelected,
                descDepartamento: this.departamentoOpcion,
                estado: this.estado,
                descUnidad: this.unidadOpcion,
                descFactura: this.selectedFacturaConciliacionReporte,
                filtraFactura: this.checkFacturados,
              },
              headers: {
                Authorization: this.token,
              },
            })
              .then((res) => {
                //if(this.estado == 'C'){
                //    this.estado = <font-awesome-icon icon="js" />
                //}

                this.vales = res.data;

                if (this.vales.length > 0) {
                  this.banderaMostrarBotonTrash = 1;
                } else {
                  this.banderaMostrarBotonTrash = 0;
                }

                this.recorreUnidadesTablaValesForUnidad(this.unidadOpcion);

                if (this.checkFacturados == false) {
                  this.checkFacturados = 0;
                }
                if (this.checkFacturados == true) {
                  this.checkFacturados = 1;
                }
              })
              .catch((err) => {
                if (
                  err.response.status == 400 ||
                  err.response.status == 304 ||
                  err.response.status == 403 ||
                  err.response.status == 404
                ) {
                  alert("Servicio no disponible, intente de nuevo más tarde");
                } else if (err.response.status == 500) {
                  alert("Error en la red, verifique su conexión a internet");
                } else {
                  if (err.config.headers.Authorization != null) {
                    const queryString = window.location.href;
                    const url = new URL(queryString);
                    const cliente = url.pathname.split("/")[1];
                    window.location.href = "/" + cliente + "/login";
                  }

                  alert(err);
                }
              });
          }
        }

        /*SI ESTA ACTIVADA LA OPCION TODAS LAS UNIDADES SE MUESTRA LA TABLA*/
        if (this.banderaTodosUnidades == 1) {
          this.unidadOpcion = null;

          if (this.reporteSelected == 3) {
            axios({
              method: "post",
              url: this.url + "vales",

              data: {
                fechaInicio: this.fechaInicio,
                fechaFinal: this.fechaFinal,
                reporteSelected: this.reporteSelected,
                descDepartamento: this.departamentoOpcion,
                estado: this.estado,
                descUnidad: this.unidadOpcion,
                descFactura: this.selectedFacturaConciliacionReporte,
                filtraFactura: this.checkFacturados,
              },
              headers: {
                Authorization: this.token,
              },
            })
              .then((res) => {
                //if(this.estado == 'C'){
                //    this.estado = <font-awesome-icon icon="js" />
                //}

                this.vales = res.data;

                if (this.vales.length > 0) {
                  this.banderaMostrarBotonTrash = 1;
                } else {
                  this.banderaMostrarBotonTrash = 0;
                }

                if (this.checkFacturados == false) {
                  this.checkFacturados = 0;
                }
                if (this.checkFacturados == true) {
                  this.checkFacturados = 1;
                }
              })
              .catch((err) => {
                if (
                  err.response.status == 400 ||
                  err.response.status == 304 ||
                  err.response.status == 403 ||
                  err.response.status == 404
                ) {
                  alert("Servicio no disponible, intente de nuevo más tarde");
                } else if (err.response.status == 500) {
                  alert("Error en la red, verifique su conexión a internet");
                } else {
                  if (err.config.headers.Authorization != null) {
                    const queryString = window.location.href;
                    const url = new URL(queryString);
                    const cliente = url.pathname.split("/")[1];
                    window.location.href = "/" + cliente + "/login";
                  }

                  alert(err);
                }
              });
          }
        }
      }
    },

    recorreUnidadesTablaVales(itemsSelected) {
      this.selectedDepartamentosTabla = itemsSelected;
      this.banderaDepartamentoTabla = 1;

      //Recorrer array de unidades y encontrar el
      //elemto que contiene las unidades del departamento seleccionado

      //Recorrer array de unidades y encontrar y crear un array
      //que contenga todas las unidades que no pertenecen al departamento selecionado

      let departamento_seleccionado2 = this.selectedDepartamentosTabla;
      //alert(departamento_seleccionado);

      this.unidadesActualTabla = [];

      //alert('3.5'+ this.unidadesTabla.length)

      for (let i = 0; i < this.unidadesTabla.length; i++) {
        //alert('4'+ this.unidadesTabla.length)
        //alert('4.5' + departamento_seleccionado2)
        //alert('5'+ this.unidadesTabla[i].descDepartamento)
        if (
          this.unidadesTabla[i].descDepartamento.includes(
            departamento_seleccionado2
          )
        ) {
          this.unidadesActualTabla.push(this.unidadesTabla[i]);

          //alert('6'+ this.unidadesActualTabla)
        } else {
          //alert('sale de vuelta')
        }
      }
    },

    recorreUnidadesTablaValesForUnidad(itemsSelectedForUnidad) {
      //this.valesPrintPantalla = JSON.stringify(this.vales)
      this.valesConsulta = this.vales;

      this.vales = [];

      //this.valesPrintPantalla = JSON.stringify(this.valesConsulta)

      for (let i = 0; i < this.valesConsulta.length; i++) {
        if (this.valesConsulta[i].unidad.includes(itemsSelectedForUnidad)) {
          this.vales.push(this.valesConsulta[i]);
        }
      }
    },

    descargaReportes() {
      //this.banderaSpinnerDescargarReporte = 1

      if (this.reporteSelected == 1) {
        var byteString = atob(this.archivoReportesBase64);
        var ab = new ArrayBuffer(byteString.length);
        var ia = new Uint8Array(ab);

        for (var i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
        }

        FileSaver.saveAs(
          new Blob([ab], { type: "application/octet-stream" }),
          this.nombreZip
        );
      }
    },

    descargaTablaVales() {
      axios({
        method: "post",
        url: this.url + "reportesum",

        data: {
          fechaInicio: this.fechaInicio,
          fechaFinal: this.fechaFinal,
          reporteSelected: this.reporteSelected,
          descDepartamento: this.departamentoOpcion,
          estado: this.estado,
          descUnidad: this.unidadOpcion,
          descFactura: this.selectedFacturaConciliacionReporte,
          filtraFactura: this.checkFacturados,
        },
        headers: {
          Authorization: this.token,
        },
      })
        .then((res) => {
          this.banderaSpinnerDescargarReporte = 1;
          this.archivoValesBase64 = res.data.xlsx;

          var byteString = atob(this.archivoValesBase64);
          var ab = new ArrayBuffer(byteString.length);
          var ia = new Uint8Array(ab);

          for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
          }

          FileSaver.saveAs(
            new Blob([ab], { type: "application/octet-stream" }),
            "Vales emitidos.xlsx"
          );

          this.banderaSpinnerDescargarReporte = 0;
        })
        .catch((err) => {
          if (
            err.response.status == 400 ||
            err.response.status == 304 ||
            err.response.status == 403 ||
            err.response.status == 404
          ) {
            alert("Servicio no disponible, intente de nuevo más tarde");

            this.banderaSpinnerDescargarReporte = 0;
          } else if (err.response.status == 500) {
            alert("Error en la red, verifique su conexión a internet");

            this.banderaSpinnerDescargarReporte = 0;
          } else {
            if (err.config.headers.Authorization != null) {
              const queryString = window.location.href;
              const url = new URL(queryString);
              const cliente = url.pathname.split("/")[1];
              window.location.href = "/" + cliente + "/login";
            }

            alert(err);
          }
        });
    },

    /*
            
    descargaTablaVales() {
 
        var byteString = atob(this.archivoValesBase64);
        var ab = new ArrayBuffer(byteString.length);
        var ia = new Uint8Array(ab);
 
        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
 
        FileSaver.saveAs(new Blob([ab],{type:"application/octet-stream"}), 'ejemplo.xlsx');
 
        },
        */
  },
};
</script>



<style>
/* BASIC */

html {
  background-color: #ffffff;
}

body {
  font-family: "Poppins", sans-serif;
  height: 100vh;
}

a {
  color: #92badd;
  display: inline-block;
  text-decoration: none;
  font-weight: 400;
}

h2 {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  text-transform: uppercase;
  display: inline-block;
  margin: 40px 8px 10px 8px;
  color: #cccccc;
}

/* STRUCTURE */

.wrapper {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  min-height: 100%;
  padding: 20px;
}

#formContent {
  -webkit-border-radius: 10px 10px 10px 10px;
  border-radius: 10px 10px 10px 10px;
  background: #fff;
  padding: 30px;
  width: 90%;
  max-width: 450px;
  position: relative;
  padding: 0px;
  -webkit-box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);
  box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);
  text-align: center;
}

#formFooter {
  background-color: #f6f6f6;
  border-top: 1px solid #dce8f1;
  padding: 25px;
  text-align: center;
  -webkit-border-radius: 0 0 10px 10px;
  border-radius: 0 0 10px 10px;
}

/* TABS */

h2.inactive {
  color: #cccccc;
}

h2.active {
  color: #0d0d0d;
  border-bottom: 2px solid #ffffff;
}

/* FORM TYPOGRAPHY*/

input[type="button"],
input[type="submit"],
input[type="reset"] {
  background-color: #56baed;
  border: none;
  color: white;
  padding: 15px 80px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  text-transform: uppercase;
  font-size: 13px;
  -webkit-box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);
  box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);
  -webkit-border-radius: 5px 5px 5px 5px;
  border-radius: 5px 5px 5px 5px;
  margin: 5px 20px 40px 20px;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}

input[type="button"]:hover,
input[type="submit"]:hover,
input[type="reset"]:hover {
  background-color: #39ace7;
}

input[type="button"]:active,
input[type="submit"]:active,
input[type="reset"]:active {
  -moz-transform: scale(0.95);
  -webkit-transform: scale(0.95);
  -o-transform: scale(0.95);
  -ms-transform: scale(0.95);
  transform: scale(0.95);
}

input[type="text"] {
  background-color: #f6f6f6;
  border: none;
  color: #0d0d0d;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 5px;
  width: 85%;
  border: 2px solid #f6f6f6;
  -webkit-transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  -ms-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
  -webkit-border-radius: 5px 5px 5px 5px;
  border-radius: 5px 5px 5px 5px;
}

input[type="text"]:focus {
  background-color: #fff;
  border-bottom: 2px solid #5fbae9;
}

input[type="text"]:placeholder {
  color: #cccccc;
}

/* ANIMATIONS */

/* Simple CSS3 Fade-in-down Animation */
.fadeInDown {
  -webkit-animation-name: fadeInDown;
  animation-name: fadeInDown;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }

  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

@keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }

  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

/* Simple CSS3 Fade-in Animation */
@-webkit-keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@-moz-keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.card-option {
  box-shadow: 0px 5px 35px 5px #cccaca;
  border-radius: 15px;
  border-bottom: solid 4px rgb(68, 63, 173);
  background-color: white;
}

.fadeIn {
  opacity: 0;
  -webkit-animation: fadeIn ease-in 1;
  -moz-animation: fadeIn ease-in 1;
  animation: fadeIn ease-in 1;

  -webkit-animation-fill-mode: forwards;
  -moz-animation-fill-mode: forwards;
  animation-fill-mode: forwards;

  -webkit-animation-duration: 1s;
  -moz-animation-duration: 1s;
  animation-duration: 1s;
}

.fadeIn.first {
  -webkit-animation-delay: 0.4s;
  -moz-animation-delay: 0.4s;
  animation-delay: 0.4s;
}

.fadeIn.second {
  -webkit-animation-delay: 0.6s;
  -moz-animation-delay: 0.6s;
  animation-delay: 0.6s;
}

.fadeIn.third {
  -webkit-animation-delay: 0.8s;
  -moz-animation-delay: 0.8s;
  animation-delay: 0.8s;
}

.fadeIn.fourth {
  -webkit-animation-delay: 1s;
  -moz-animation-delay: 1s;
  animation-delay: 1s;
}

/* Simple CSS3 Fade-in Animation */
.underlineHover:after {
  display: block;
  left: 0;
  bottom: -10px;
  width: 0;
  height: 2px;
  background-color: #56baed;
  content: "";
  transition: width 0.2s;
}

.underlineHover:hover {
  color: #0d0d0d;
}

.underlineHover:hover:after {
  width: 100%;
}

/* OTHERS */

*:focus {
  outline: none;
}

#icon {
  width: 60%;
}
</style>